export const config={
    auth: {
        authority : process.env.REACT_APP_AZURE_AUTHORITY,
        clientId : process.env.REACT_APP_AZURE_CLIENT_ID,
        postLogoutRedirectUri : window.location.origin,
        redirectUri : window.location.origin,
        validateAuthority : true,
        navigateToLoginRequestUrl : true,
        
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    }
}